import { IGetListParams } from './../../../base/base.service';
import { NotesService, INote } from "../../../services";

class DashboardNotesController {
    private notes: INote[];
    constructor(private NotesService: NotesService) {
        "ngInject";
    }

    public $onInit = () => {
        this.getNotes();
    }

    public getNotes = () => {
        const params: IGetListParams = {
            limit: 5000,
            sortfield: 'createdOn',
            sortorder: 'desc'
        }
        this.NotesService.all(params)
            .then((notes) => {
                this.notes = notes.filter(note => !note.applicantId).slice(0, 10);
            })
    }

    getNoteAuthorName(note) {
        if (note.accountName) return note.accountName;
        if (note.employeeDisplayName) return note.employeeDisplayName;
        if (note.applicantName) return note.applicantName;
        return '';
    }
}

export const dashboardNotesComponent = {
    controller: DashboardNotesController,
    template: require('./dashboardNotes.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/notes/dashboardNotes.component.ts